export default __webpack_public_path__ + "static/media/wishlist2.bf67198a.jpg";